import {
    GET_ADMINS,
    API_RESPONSE_SUCCESS,
    API_RESPONSE_ERROR,
  
    UPDATE_ADMIN,
    UPDATE_ADMIN_SUCCESS,
    UPDATE_ADMIN_FAIL,
    
    ADD_NEW_ADMIN,
    ADD_ADMIN_SUCCESS,
    ADD_ADMIN_FAIL,

  } from "./actionType";

  // common success
  export const adminApiResponseSuccess = (actionType, data) => ({
    type: API_RESPONSE_SUCCESS,
    payload: { actionType, data },
  });
  // common error
  export const adminApiResponseError = (actionType, error) => ({
    type: API_RESPONSE_ERROR,
    payload: { actionType, error },
  });
  
  export const getAdmins = () => ({
    type: GET_ADMINS,
  });

  export const updateAdmin = admin => ({
    type: UPDATE_ADMIN,
    payload: admin,
  });
  
  export const updateAdminSuccess = admin => ({
    type: UPDATE_ADMIN_SUCCESS,
    payload: admin,
  });
  
  export const updateAdminFail = error => ({
    type: UPDATE_ADMIN_FAIL,
    payload: error,
  });
  
  export const addNewAdmin = admin => ({
    type: ADD_NEW_ADMIN,
    payload: admin,
  });
  
  export const addAdminSuccess = admin => ({
    type: ADD_ADMIN_SUCCESS,
    payload: admin,
  });
  
  export const addAdminFail = error => ({
    type: ADD_ADMIN_FAIL,
    payload: error,
  });